import { Pipe } from '@angular/core';
import { KompaktdarstellungPipe } from '../../kompakt-darstellung.pipe';
import { FormatConfigService } from '../../../../core/services/format-config.service';
import { PlatformLocation } from '@angular/common';
import { ComponentLocationStrategy } from '../../../services/location-strategy/component-location-strategy';
import { GrundstueckArtPipe } from '../../../pipes/simple/grundstueck-art.pipe';
import { GrundstuecknummerPipe } from '../../../pipes/simple/grundstuecknummer.pipe';
import { TranslateService } from '@ngx-translate/core';
import { GrundstueckDetailEntryMeta } from '../../../../core/gb-api';
import { GrundstueckArtLangPipe } from '../../../pipes/simple/grundstueck-art-lang.pipe';

@Pipe({
  name: 'kompaktGrundstueckDetail'
})
export class KompaktGrundstueckDetailPipe extends KompaktdarstellungPipe<GrundstueckDetailEntryMeta> {
  constructor(
    protected formatConfigService: FormatConfigService,
    protected location: PlatformLocation,
    protected kompaktLocation: ComponentLocationStrategy,
    private grundstArtPipe: GrundstueckArtPipe,
    private grundstArtLangPipe: GrundstueckArtLangPipe,
    private grundstueckNummerPipe: GrundstuecknummerPipe,
    private translate: TranslateService
  ) {
    super(formatConfigService, 'GRUNDSTUECK', location, kompaktLocation);
  }

  transform(entry: GrundstueckDetailEntryMeta, languageChangeEvent = 'de'): string {
    if (!entry) {
      return;
    }
    const kopie = entry.isKopie ? ' (' + this.translate.instant('GrundstückKopie') + ')' : '';
    const value = this.grundstueckNummerPipe.transform(entry.grundstueckNummern[entry.grundstueckNummern.length - 1]) + kopie;
    if (this.formatElement === 'GRUNDSTUECK_TYP00') {
      return this.grundstArtPipe.transform(entry, languageChangeEvent) + ' ' + value;
    }
    if (this.formatElement === 'GRUNDSTUECK_TYP01') {
      return value;
    }
    if (this.formatElement === 'GRUNDSTUECK_TYP02') {
      return this.grundstArtLangPipe.transform(entry, languageChangeEvent) + ' ' + value;
    }
    return value;
  }
}
